import Typography from '@mui/material/Typography';

export default function NotFound() {
    return (
        <>
            <Typography variant="h4" align="left" gutterBottom component="h2">
                404 Not Found
            </Typography>
        </>
    )
};
